import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import {setPartGroupLoading} from './LoadingReducer';

export const setPartList = createAction('SET_PART_LIST');
export const loadPartList = (action = {}) => (dispatch, getState) => {
  const {partID, carSize, carType} = action;

  dispatch(setPartGroupLoading({loading: true}));
  axios.get(`/damage/part_item/${partID}/work?format=json`).
      then((response) => {
        const data = response.data && response.data.data
                     && response.data.data.list || [];
        dispatch(setPartList({
          data: data,
          payload: action,
        }));
        dispatch(setPartGroupLoading({loading: false}));
      }).
      catch((error) => {
        console.error(error);
      });
};

export const PartReducer = (defaultState) => handleActions({
  loadPartList,
  [setPartList](state, action = {}) {
    const {data, payload} = action.payload || {};
    return data || [];
  },
}, defaultState);

export default PartReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/PartReducer.js